import { render, staticRenderFns } from "./TrialMonitoring.vue?vue&type=template&id=4a72f721&scoped=true"
import script from "./TrialMonitoring.vue?vue&type=script&lang=js"
export * from "./TrialMonitoring.vue?vue&type=script&lang=js"
import style0 from "./TrialMonitoring.vue?vue&type=style&index=0&id=4a72f721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72f721",
  null
  
)

export default component.exports